import { MAX_FILE_SIZE_20MB, MAX_FILE_SIZE_5MB } from '@/common/constants';
import * as Yup from 'yup';

export const settingSchema = Yup.object({
    ppn: Yup.string()
        .trim()
        .required('PPN is required'),
    adminEmailRecipient: Yup.string()
        .trim()
        .email('Enter a valid email address'),
    emailCC: Yup.string()
        .trim()
        .email('Enter a valid email address'),
    emailProcessCC: Yup.string()
        .trim()
        .email('Enter a valid email address'),
    emailSireReview: Yup.string()
        .trim()
        .email('Enter a valid email address'),
    files: Yup.mixed().nullable()
        .test('fileSize', 'File size is too large', (value: any) => {
            if (value && (value as File).size > MAX_FILE_SIZE_5MB) {
                return false;
            }
            return true;
        }),
    manualAdmin: Yup.mixed().nullable()
        .test('fileSize', 'File size is too large', (value: any) => {
            if (value && (value as File).size > MAX_FILE_SIZE_20MB) {
                return false;
            }
            return true;
        }),
    manualFinance: Yup.mixed().nullable()
        .test('fileSize', 'File size is too large', (value: any) => {
            if (value && (value as File).size > MAX_FILE_SIZE_20MB) {
                return false;
            }
            return true;
        }),
    manualShipOperator: Yup.mixed().nullable()
        .test('fileSize', 'File size is too large', (value: any) => {
            if (value && (value as File).size > MAX_FILE_SIZE_20MB) {
                return false;
            }
            return true;
        }),
    manualInspectingCo: Yup.mixed().nullable()
        .test('fileSize', 'File size is too large', (value: any) => {
            if (value && (value as File).size > MAX_FILE_SIZE_20MB) {
                return false;
            }
            return true;
        }),
    manualRequestor: Yup.mixed().nullable()
        .test('fileSize', 'File size is too large', (value: any) => {
            if (value && (value as File).size > MAX_FILE_SIZE_20MB) {
                return false;
            }
            return true;
        }),
});
